"use client";
import { jsxs as e, jsx as s } from "react/jsx-runtime";
import { CmsBackofficeLink as t } from "./EditLinkWrapper/EditLinkWrapper.js";
const f = (o, i) => /* @__PURE__ */ e("div", { style: { position: "relative" }, children: [
  i && /* @__PURE__ */ s(t, { ...i }),
  o
] });
export {
  f as withCmsBackofficeHandling
};
